import { makeStyles } from 'makeStyles';
import { ALERT_BACKGROUND, ALERT_BACKGROUND_BORDER } from 'theme/colors';

export const useStyles = makeStyles()(() => ({
  accordionSummaryChildren: {
    marginLeft: 'auto',
    paddingTop: 2,
    marginRight: 5,
  },
  alertWrapper: {
    backgroundColor: ALERT_BACKGROUND,
    border: `1px solid ${ALERT_BACKGROUND_BORDER}`,
    borderRadius: 3,
    marginTop: 20,
    padding: 10,
  },
  alertContainer: {
    margin: '30px 2px 0 0',
    padding: '17px 17px 20px 21px',
    borderRadius: 4,
    border: 'solid 1px rgba(221, 157, 59, 0.3)',
    backgroundColor: '#fffbed',
  },
  playerName: {
    fontSize: 20,
    fontWeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#3e424e',
  },
  actionsContainer: {
    marginTop: 24,
    padding: '8px 0 8px 0',
  },
  noEvents: {
    marginTop: 20,
  },
  bullet: {
    color: '#3e424e',
    fontSize: 15,
  },
  note: {
    marginTop: 20,
  },
  error: {
    color: '#c21a2d',
    marginTop: 20,
  },
  spacing: {
    marginBottom: 20,
  },
  eligibilityItem: {
    display: 'flex',
    alignItems: 'center',
  },
  list: {
    padding: 0,
  },
  listItem: {
    '&::marker': {
      width: 6,
      fontSize: 20,
    },
  },
  loading: {
    display: 'flex',
    margin: '20px auto',
  },
}));
